import { render, staticRenderFns, recyclableRender, components } from "./merchantSubmit.vue?vue&type=template&id=65b65617&scoped=true&"
var renderjs
import script from "./merchantSubmit.vue?vue&type=script&lang=js&"
export * from "./merchantSubmit.vue?vue&type=script&lang=js&"
import style0 from "./merchantSubmit.vue?vue&type=style&index=0&id=65b65617&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b65617",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/merchant/applyMerchant/merchantSubmit.vue"
export default component.exports